var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-copyright-text text-xs-center"},[_vm._v("\n    © Copyright "+_vm._s(new Date().getFullYear())+" SweldoNow OPC. All Rights Reserved.\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }